import { Box } from '@mui/material';
import { Formik } from 'formik';
import { type FC, useState } from 'react';

import { NewFeatureHeader, Page } from '@web/components';
import { SlabTabs } from '@web/components/SlabTabs/SlabTabs';

import { ActualsTabs, type BacklogFiltersFormikType, tabs } from '../../utils/backlog';
import { LocationPerformance } from './LocationPerformance/LocationPerformance';
import { MetricCards } from './MetricCards';

export const ObfuscatedActualsPage: FC = () => {
  const [projectIDs] = useState<string[]>([]);

  return (
    <Page title='Backlog'>
      <Formik<BacklogFiltersFormikType>
        initialValues={{
          project: [],
          productCategory: null,
          markets: [],
          salespersons: [],
        }}
        onSubmit={() => {}}
      >
        {() => (
          <>
            <NewFeatureHeader
              featureName='Backlog'
              promoLines={[
                'Stop guessing which projects will hit and which are slipping. Track how your',
                'quotes translate to real production, compare forecasted vs. actual quantities, and',
                'identify at-risk projects across all your locations before they slip.',
              ]}
              sx={{ marginBottom: '3.75rem' }}
            />
            <Box sx={{ position: 'relative' }}>
              <MetricCards projectIDs={projectIDs} />
              <Box sx={{ mt: 4, mb: 8 }}>
                <SlabTabs
                  onChange={() => {
                    /* just show that we have the functionality */
                  }}
                  value={ActualsTabs.DASHBOARD_OVERVIEW}
                  items={tabs.map(({ label }) => ({ value: label, label }))}
                  disabled
                />
                <Box sx={{ mt: 3 }}>
                  <LocationPerformance previewMode />
                </Box>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  zIndex: 10,
                  pointerEvents: 'all', // blocks interaction
                  backdropFilter: 'blur(4px)',
                  WebkitBackdropFilter: 'blur(4px)',

                  maskImage: `
      linear-gradient(
        to bottom,
        rgba(0,0,0,0) 0px,
        rgba(0,0,0,1) 600px
      )
    `,
                  WebkitMaskImage: `
      linear-gradient(
        to bottom,
        rgba(0,0,0,0) 0px,
        rgba(0,0,0,1) 600px
      )
    `,
                }}
              />
            </Box>
          </>
        )}
      </Formik>
    </Page>
  );
};
